import { TypedDocumentNode, gql } from '@apollo/client';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { CSSProperties } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelM } from '@sorare/core/src/atoms/typography';
import { Bold } from '@sorare/core/src/atoms/typography/Bold';

import type { BaseObjectiveBar_so5Leaderboard } from './__generated__/index.graphql';

const Root = styled(Horizontal).attrs({ center: true })`
  padding: var(--unit);
  background: linear-gradient(180deg, var(--color) 0%, transparent 100%);
`;

type Props = {
  so5Leaderboard: BaseObjectiveBar_so5Leaderboard;
  completed?: boolean;
};
export const BaseObjectiveBar = ({ so5Leaderboard, completed }: Props) => {
  return (
    <Root
      style={
        { '--color': so5Leaderboard.so5LeaderboardGroup.color } as CSSProperties
      }
    >
      <FontAwesomeIcon
        icon={faCheckCircle}
        color={completed ? 'var(--c-green-400)' : 'var(--c-nd-500)'}
      />
      <LabelM>
        <FormattedMessage
          id="Compose.ObjectiveBar.createFirstTeam"
          defaultMessage="<b>Objective:</b> Compose your first team"
          values={{ b: Bold }}
        />
      </LabelM>
    </Root>
  );
};

BaseObjectiveBar.fragments = {
  so5Leaderboard: gql`
    fragment BaseObjectiveBar_so5Leaderboard on So5Leaderboard {
      slug
      so5LeaderboardGroup {
        slug
        color
      }
    }
  ` as TypedDocumentNode<BaseObjectiveBar_so5Leaderboard>,
};
